<script>
    import moment from 'moment'
    import pl from 'moment/locale/pl'
    import Rest from "../public/lib/rest";
    import Common from "../public/lib/common";

    let newCost = {
        taxType: 'BRUTTO',
        type: 'CASH'
    };

    let cars = [];
    let costs = [];
    let costsMap = {};

    export function setup(data) {
        cars = data.cars;
        reloadCosts();
    }

    function reloadCosts() {
        costs = [];
        let costsMap = {};
        Rest.getCosts().then(function (response) {
            response.value.forEach(function (cost) {
                cost.costDateStr = moment.unix(cost.costDate / 1000).format('DD-MM');
                cost.nettoPrice = Common.getNetto(cost.price, cost.taxType); //120;
                let month = moment.unix(cost.costDate / 1000).format('MMMM YYYY');
                if (!costsMap[month]) {
                    costsMap[month] = {
                        data: month,
                        values: [],
                        total: 0
                    }
                }
                costsMap[month].values.push(cost);
                costsMap[month].total = parseInt(costsMap[month].total) + parseInt(cost.nettoPrice);
            });
            for (var key of Object.keys(costsMap)) {
                costsMap[key].values = costsMap[key].values.sort(function (a, b) {
                    return b.costDate.localeCompare(a.costDate);
                });
                costs.push(costsMap[key]);
            }
            costsMap = costsMap;
            costs = costs;
        }).catch(function (present) {
        });
    }

    function saveNewCost() {
        Rest.saveCost(newCost).then(function (response) {
            alert("Zapisano");
            newCost = {
                taxType: 'BRUTTO',
                type: 'CASH'
            };
            jQuery('#newCostModal').modal('toggle');
            reloadCosts();
        }).catch(function (present) {
            present.json().then(body => {
                alert(body.description);
            });
        });
    }

    function showNewCostModal() {
        let w = jQuery('#newCostModal').modal();
        jQuery('#costDate').flatpickr({
            dateFormat: "d-m-Y",
            minDate: new Date().fp_incr(-30),
            maxDate: new Date().fp_incr(14)
        });
    }

</script>
<div class="row">
    <div class="col-12 mt-4">
        <main class="chart-container menuButtonsContainer">
<!--            <button type="button"-->
<!--                    class="menuButton btn  btn-info maxWt200"-->
<!--                    on:click="{showNewCostModal}">-->
<!--                <span><i class="fas fa-plus"></i> Nowy koszt</span>-->
<!--            </button>-->
        </main>

        {#each costs as cost}
            <main class="chart-container mt-4 ">
                <div class="largeFontDiv">{cost.data} - łącznie: {cost.total} netto</div>
                <table class="table table-dark noMarginBottom">
                    <thead>
                    <tr>
                        <th class="d-none d-sm-table-cell">Data</th>
                        <th>Kwota</th>
                        <th>Kwota netto</th>
                        <th class="d-none d-sm-table-cell">Faktura</th>
                        <th>Typ</th>
                        <th>Opis</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each cost.values as entry}
                        <tr>
                            <td class="d-none d-sm-table-cell">{entry.costDateStr}</td>
                            <td>{entry.price}</td>
                            <td>{entry.nettoPrice}</td>
                            <td class="d-none d-sm-table-cell">
                                {#if entry.taxType === 'BRUTTO'}
                                    TAK
                                    {#if entry.invoiceName}
                                        &nbsp;-&nbsp;{entry.invoiceName}
                                    {/if}
                                {/if}
                                {#if entry.taxType === 'NETTO'}
                                    TAK (bez VAT)
                                {/if}
                                {#if entry.taxType === 'CASH'}
                                    NIE
                                {/if}
                            </td>
                            <td>
                                {#if entry.type === 'CASH'}
                                    Gotówka
                                {/if}
                                {#if entry.type === 'TRANSFER'}
                                    Przelew na konto
                                {/if}
                            </td>
                            <td>
                                {entry.description}
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </main>
        {/each}
    </div>
</div>


<div class="modal" tabindex="-1" role="dialog" id="newCostModal" style="z-index: 2000; color: black">
    <div class="modal-dialog largeModalDialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title largeFont">Nowy koszt</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-12 col-lg-6">

                        <div class="form-group">
                            <label>Auto </label>
                            <select bind:value={newCost.carUuid}>
                                <option value="">
                                    Nie związane z autem
                                </option>
                                {#each cars as car}
                                    <option value={car.uuid}>
                                        {car.name} - {car.registrationNumber}
                                    </option>
                                {/each}
                            </select>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Kwota </label>
                            <input type="number" class="form-control"
                                   placeholder="Kwota"
                                   bind:value={newCost.price}>
                        </div>


                        <div class="form-group approveToggle">
                            <label for="">Faktura </label>
                            <label class="form-switch">

                                <select bind:value={newCost.taxType}>
                                    <option value="CASH">
                                        Gotówka
                                    </option>
                                    <option value="NETTO">
                                        Faktura BEZ VAT
                                    </option>
                                    <option value="BRUTTO">
                                        Faktura VAT
                                    </option>
                                </select>
                            </label>
                        </div>

                        {#if newCost.taxType === 'BRUTTO'}
                            <div class="form-group">
                                <label for="invoiceName">Numer faktury</label>
                                <input type="text" class="form-control" id="invoiceName"
                                       placeholder="Numer faktury"
                                       bind:value={newCost.invoiceName}>
                            </div>
                        {/if}

                    </div>
                    <div class="col-12 col-lg-6">

                        <div class="form-group">
                            <label for="formGroupExampleInput2">Data kosztu</label>
                            <input type="text" class="form-control" id="costDate"
                                   placeholder="Data kosztu"
                                   bind:value={newCost.costDate}>
                        </div>

                        <div class="form-group">
                            <label>Forma wpłaty </label>
                            <select bind:value={newCost.type}>
                                <option value="CASH">
                                    Gotówka
                                </option>
                                <option value="TRANSFER">
                                    Przelew
                                </option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Info </label>
                            <textarea cols="50" rows="5" bind:value={newCost.description}></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-info" on:click={saveNewCost}><i class="fas fa-save"></i>&nbsp;Zapisz
                </button>
            </div>
        </div>
    </div>
</div>

